<div class="card-list">
  <ng-content></ng-content>
</div>
